module.exports = __webpack_public_path__ + "img/logo-ken.dac579cb.png";